import React, { useState } from "react"
import * as FileSaver from "file-saver"
import * as XLSX from "xlsx"
import { Link } from "react-router-dom"
import { Spinner } from "reactstrap"
import { get } from "helpers/api_helper"
import moment from "moment"

export const DownLoadFile = ({
  colorBox = "btn-success",
  disabled = false,
  interviewId,
  exportType,
}) => {
  const [exportLoading, setExportLoading] = useState(false)

  const handleExport = async () => {
    if (disabled) return

    try {
      setExportLoading(true)

      const endpoint =
        exportType === "evaluate"
          ? process.env.REACT_APP_BACKEND_URL +
            "/v1/admin/interview-dialog/dialog/" +
            interviewId +
            "/download"
          : process.env.REACT_APP_BACKEND_URL +
            "/v1/admin/interview-dialog/summary/" +
            interviewId +
            "/download"

      const response = await get(endpoint)

      console.log("API Response:", response)

      // Check both number and string versions of status to be safe
      if (
        response &&
        (response.status === 200 || response.status === "200") &&
        response.fileUrl
      ) {
        const urlParts = response.fileUrl.split("/")
        const filename = urlParts[urlParts.length - 1]

        fetch(response.fileUrl)
          .then(res => res.blob())
          .then(blob => {
            FileSaver.saveAs(blob, filename)
          })
          .catch(error => {
            console.error("Error fetching or saving file:", error)
          })
      } else {
        // Check if response has data property (common wrapper pattern)
        if (
          response &&
          response.data &&
          (response.data.status === 200 || response.data.status === "200") &&
          response.data.fileUrl
        ) {
          const urlParts = response.data.fileUrl.split("/")
          const filename = urlParts[urlParts.length - 1]

          fetch(response.data.fileUrl)
            .then(res => res.blob())
            .then(blob => {
              FileSaver.saveAs(blob, filename)
            })
            .catch(error => {
              console.error("Error fetching or saving file:", error)
            })
        } else {
          console.error("Failed to get file URL", response)
        }
      }
    } catch (error) {
      alert(`System error, Please try again.`)
    } finally {
      setExportLoading(false)
    }
  }

  return (
    <a
      className={`btn ${disabled ? "btn-secondary" : colorBox}`}
      onClick={handleExport}
      aria-label="Download file"
      style={{
        opacity: disabled ? 0.6 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      {exportLoading ? (
        <Spinner size="sm" className="" color="light" style={{ zoom: "0.8" }} />
      ) : (
        <i className="bx bx-export" />
      )}
    </a>
  )
}
